import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./Pages/index";
import MainLayout from "./Layout/MainLayout";
import UserManage from "./Pages/UserManagement/UserManagement";
import "./Assets/global.css";
import Licensemanagement from "./Pages/LicenseManagement/Licensemanagement";
import CarBooking from "./Pages/Bookings/CarBooking";
import CarListing from "./Pages/CarListings/CarListing";
import Add from "./Pages/CarListings/Add";
import CarDetails from "./Pages/CarListings/CarDetails";
import ManageUser from "./Pages/ManageUser/ManageUser";
import AddUser from "./Pages/ManageUser/AddUser";
import ChangePassword from "./Pages/ChangePassword/ChangePassword";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from "./Pages/Login/Login";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <MainLayout>
              <Dashboard />
            </MainLayout>
          }
        />
        <Route
          path="/users"
          element={
            <MainLayout>
              <UserManage />
            </MainLayout>
          }
        />
        {/* <Route
          path="/invoices"
          element={
            <MainLayout>
              <InvoiceRecords />
            </MainLayout>
          }
        /> */}
        <Route
          path="/licenses"
          element={
            <MainLayout>
              <Licensemanagement />
            </MainLayout>
          }
        />
        <Route path="/bookings" element={<MainLayout><CarBooking /></MainLayout>}/>
        <Route path="/car-listings" element={<MainLayout><CarListing /></MainLayout>}/>
        <Route path="/car-listings/add" element={<MainLayout><Add /></MainLayout>}/>
        <Route path="/car-listings/edit" element={<MainLayout><Add /></MainLayout>}/>
        <Route path="/car-listings/car-details/:id" element={<MainLayout><CarDetails /></MainLayout>} />
        <Route path="/manage-user" element={<MainLayout><ManageUser /></MainLayout>} />
        <Route path="/manage-user/add" element={<MainLayout><AddUser /></MainLayout>} />
        <Route path="/manage-user/edit" element={<MainLayout><AddUser /></MainLayout>} />
        <Route path="/change-password" element={<MainLayout><ChangePassword /></MainLayout>} />
        <Route path="/" element={<Login />} />
 
        
      </Routes>
      <ToastContainer
          position="top-center"
          autoClose={2500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
    </BrowserRouter>
  );
}

export default App;
